import { faMailBulk } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import Link from 'next/link';

import { publicEnv } from '@/lib/env';

interface ContactLeagueButtonProps {
	teamLeagueId: string;
	useRegularStyling?: boolean;
	className?: string;
}

export const ContactLeagueButton = ({ teamLeagueId, useRegularStyling, className }: ContactLeagueButtonProps) => {
	return (
		<Link
			className={clsx(
				'bg-warning-300 text-gray-900 text-nowrap w-full md:w-52 justify-center text-sm font-semibold flex gap-2 items-center py-2 px-3 rounded-lg',
				useRegularStyling && 'text-xs py-1 px-2',
				className
			)}
			href={`${publicEnv.NEXT_PUBLIC_CONTACT_FORM_URL}/contacts/team-league/${teamLeagueId}`}
			prefetch={false}
		>
			<FontAwesomeIcon icon={faMailBulk} className="size-4" />
			Contact League
		</Link>
	);
};
